import React, { useEffect, useState } from "react";
import "./DashboardPaymentPage.css";
import { useNavigate } from "react-router-dom";
import { Divider, Image, Loader } from "@mantine/core";
import DetailUser from "../component/DetailUser";
import logo from "../../assets/promptpay.png";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
  number_true: string;
  creck: string;
  vut: string;
  type_std_name: string;
}

export default function DashboardPaymentPage() {
  const nav = useNavigate();
  const [dataUser, SetdataUser] = useState<RowDataUser>();

  const [valueRegister, setValueRegister] = useState<string[]>(["1"]);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));
  };

  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="DashboardSelectRegisterPage">
      <section>
        <DetailUser />
      </section>
      <Divider my="xs" size="md" color="blue" />
      <section>
        
      </section>
    </div>
  );
}
